import {MiniMergeStatusItem} from './MiniMergeStatusItem'
import type {MiniStatusIconProps} from './MiniStatusIcon'

import {
  isSuccessStatus,
  type CombinedState,
  type StatusRollup,
} from '@github-ui/mergebox/page-data/payloads/status-checks'
import {useGoToMergeBox} from '../../../mergebox/use-go-to-mergebox'

export type ChecksMiniStatusProps = {
  statusRollup: StatusRollup
}

const iconTypeByCombinedState: Record<CombinedState, MiniStatusIconProps['type']> = {
  PASSED: 'success',
  PENDING: 'warning',
  PENDING_APPROVAL: 'warning',
  PENDING_CONFLICTS: 'warning',
  FAILED: 'failure',
  PENDING_FAILED: 'failure',
  SOME_FAILED: 'failure',
}

export function ChecksMiniStatus({statusRollup}: ChecksMiniStatusProps) {
  const goToMergeBox = useGoToMergeBox()

  let successfulChecks = 0
  let totalChecks = 0

  for (const summary of statusRollup.summary) {
    totalChecks += summary.count

    if (isSuccessStatus(summary.state)) {
      successfulChecks += summary.count
    }
  }

  return (
    <MiniMergeStatusItem aria-label="Checks">
      <MiniMergeStatusItem.LabelRow>
        <MiniMergeStatusItem.Label
          icon={iconTypeByCombinedState[statusRollup.combinedState] ?? 'warning'}
          successful={successfulChecks}
          total={totalChecks}
        >
          Checks
        </MiniMergeStatusItem.Label>

        <MiniMergeStatusItem.Action
          aria-label="View checks"
          // TODO: Update the panel to open the checks section in the merge status panel. The current open panel options
          // don't support expanding sections within the merge status panel
          onClick={event => goToMergeBox(event.currentTarget)}
        />
      </MiniMergeStatusItem.LabelRow>
      <MiniMergeStatusItem.Progress
        aria-label={`${successfulChecks} of ${totalChecks} successful checks`}
        successful={successfulChecks}
        total={totalChecks}
      />
    </MiniMergeStatusItem>
  )
}
